import React from 'react';

export default ({ color = '#251FB6', size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.26135 1.87953L11.141 5.12508H13.1373V6.29255H12.4602L12.0166 11.5928C12.001 11.7485 11.9368 11.8769 11.8239 11.9781C11.7111 12.0793 11.5807 12.1299 11.4328 12.1299H3.16718C3.0193 12.1299 2.88893 12.0793 2.77608 11.9781C2.66322 11.8769 2.59901 11.7485 2.58344 11.5928L2.13981 6.29255H1.46268V5.12508H3.45904L5.33867 1.87953L6.34269 2.46326L4.81331 5.12508H9.78671L8.25733 2.46326L9.26135 1.87953ZM11.2811 6.29255H3.31895L3.70421 10.9624H10.8958L11.2811 6.29255ZM7.88374 7.46002V9.79495H6.71628V7.46002H7.88374ZM5.54881 7.46002V9.79495H4.38134V7.46002H5.54881ZM10.2187 7.46002V9.79495H9.05121V7.46002H10.2187Z"
      fill={color}
    />
  </svg>
);
